import { createAsyncStateHook } from './utils'
import { getGlobalState } from 'src/services/globalServices'

export const useGlobalStats = createAsyncStateHook(
  'globalStats',
  getGlobalState
)
